import script from "./WithFirstParent.vue?vue&type=script&lang=js"
export * from "./WithFirstParent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__